import axios from '@axios'
import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchStaffs(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/list', {params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    fetchStaff(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`/`, {params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    addStaff(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('/', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteStaff(ctx, queryParams) {
      return new Promise((resolve, reject) => {
         axiosIns.delete('/', { params: queryParams })
         .then(response=>resolve(response))
         .catch(error=>reject(error))
      })
    },
    toggleActive(ctx, payload) {
      return new Promise((resolve, reject) => {
        axiosIns.post('/toggle-active', payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    exportStaffs(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/export', { params: queryParams, responseType: "blob" })
        .then(response=>resolve(response))
        .catch(error=>reject(error))
      })
    },
  },
}
